import React, { useContext } from "react";
import {
    Card, List, ListItem, ListItemButton, ListItemIcon, ListItemText,
    Divider,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from "react-router-dom";
import UserContext from "./UserContext";
import API from "../../api2";

interface OptionItem {
    text: string;
    icon: React.ReactNode;
    link: string;
}

interface HomeSettingsCardProps {
    closeCard: () => void;
}

function HomeSettingsCard({ closeCard }: HomeSettingsCardProps) {
    const navigate = useNavigate();
    const { user, setUser } = useContext(UserContext) || { user: null };
    const optionsArray: OptionItem[] = [
        { text: 'Settings', icon: <SettingsIcon />, link: '/settings' },
        { text: 'Logout', icon: <LogoutIcon />, link: '/logout' },
    ];

    const redirect = (link: string) => {
        if (link === '/logout') {
            localStorage.removeItem('user');
            API.token = null;
            if (setUser) setUser({ token: null, mode: 'dark' });
            navigate('/login');
        } else navigate(link);
        return closeCard();
    }

    return (
        <Card key="HomeSettingsCard" sx={{ borderRadius: '10%' }}>
            <List>
                {optionsArray.map((obj, index) => (
                    <React.Fragment key={obj.text}>
                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    px: 2.5,
                                }}
                                onClick={() => redirect(obj.link)}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        justifyContent: 'center',
                                    }}
                                >
                                    {obj.icon}
                                </ListItemIcon>
                                <ListItemText
                                    primary={obj.text}
                                    sx={{ opacity: 1, ml: 3 }}
                                />
                            </ListItemButton>
                        </ListItem>
                        {optionsArray.length - 1 !== index ? <Divider /> : null}
                    </React.Fragment>
                ))}
            </List>
        </Card>
    )
}

export default HomeSettingsCard;